const clamp = (value, min, max, fallback) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
};

export function defaultTrackEffects() {
  return {
    eq: { low: 0, mid: 0, high: 0 },
    highPassHz: 0,
    lowPassHz: 0,
    lowPassResonance: 0,
    reverb: 0,
    echo: 0,
    punch: 0,
  };
}

export function normalizeTrack(track = {}) {
  const effects = track.effects && typeof track.effects === 'object' ? track.effects : {};
  const eq = effects.eq && typeof effects.eq === 'object' ? effects.eq : {};
  const defaults = defaultTrackEffects();
  return {
    ...track,
    volume: clamp(track.volume, 0, 100, 80),
    pan: clamp(track.pan, -50, 50, 0),
    muted: Boolean(track.muted),
    solo: Boolean(track.solo),
    effects: {
      eq: {
        low: clamp(eq.low, -12, 12, defaults.eq.low),
        mid: clamp(eq.mid, -12, 12, defaults.eq.mid),
        high: clamp(eq.high, -12, 12, defaults.eq.high),
      },
      highPassHz: clamp(effects.highPassHz ?? effects.hpf, 0, 1000, defaults.highPassHz),
      // Legacy lpf was not audible in this engine; keep old projects unchanged.
      lowPassHz: (() => {
        const hz = clamp(effects.lowPassHz, 0, 20000, 0);
        return hz <= 0 || hz >= 20000 ? 0 : Math.max(20, hz);
      })(),
      lowPassResonance: clamp(effects.lowPassResonance, 0, 1, 0),
      reverb: clamp(effects.reverb, 0, 1, defaults.reverb),
      echo: clamp(effects.echo ?? effects.delay, 0, 1, defaults.echo),
      punch: clamp(effects.punch, 0, 1, defaults.punch),
    },
    clips: Array.isArray(track.clips) ? track.clips : [],
  };
}
